/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';

export const BlockListBlockContext = createContext( null );
